
import { createContext } from 'react';

export const TextAncestorContext = createContext(false);